import { Component, EventEmitter, Output } from '@angular/core';
import { ApiService } from 'src/app/core/api.service';
import * as AmdocsContentConstants from '../../../content.constants';

@Component({
  selector: 'app-maintenance-popup',
  templateUrl: './maintenance-popup.component.html',
  styleUrls: ['./maintenance-popup.component.scss']
})
export class MaintenancePopupComponent  {

  public amdocsContentConstant: any = AmdocsContentConstants?.default;
  @Output() onCloseCallback: EventEmitter<any> = new EventEmitter();
  constructor(
    private apiService: ApiService
  ) { }

  close(): void {
    this.apiService.updateLearningPopupStatus(true).subscribe();
    this.onCloseCallback.emit();
  }
}
